
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 5.5V4.25A1.25 1.25 0 008.75 3h-6A1.25 1.25 0 001.5 4.25v7.5A1.25 1.25 0 002.75 13h6A1.25 1.25 0 0010 11.75V10.5","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 5.5L14.5 8 12 10.5M5.969 8H14.5","stroke":"#09C554","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    